import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { appointmentConsentsModalActions } from '../../../../../redux/healthboard/appointment-consent-modal';
import {
  selectAppointmentAllConsentState,
  selectAppointmentConsentsModalOpen,
  selectAppointmentConsentsModalOpenUrgentVisit,
  selectAppointmentConsentsModalOpenSelfScheduling,
  selectAppointmentConsentTime,
  selectAppointmentCurrentConsentState,
  selectAppointmentOrganizationName,
  selectAppointmentServiceName,
  selectIsMainConsentViewState,
  selectPatientUserInfoIdWithAppointmentState,
  selectAppointmentConsentsModalOpenRescheduleFlow,
  selectSignAppointmentConsentLoading,
} from '../../../../../redux/healthboard/selectors';
import { hasProviderProfileSelector } from '../../../../../redux/context/selectors';

const mapStateToProps = state => ({
  providerContext: hasProviderProfileSelector(state),
  userId: selectPatientUserInfoIdWithAppointmentState(state),
  isOpened: selectAppointmentConsentsModalOpen(state),
  isMainConsentView: selectIsMainConsentViewState(state),
  currentConsent: selectAppointmentCurrentConsentState(state),
  organizationName: selectAppointmentOrganizationName(state),
  serviceName: selectAppointmentServiceName(state),
  timeConsent: selectAppointmentConsentTime(state),
  allConsents: selectAppointmentAllConsentState(state),
  urgentVisitFlow: selectAppointmentConsentsModalOpenUrgentVisit(state),
  selfSchedulingFlow: selectAppointmentConsentsModalOpenSelfScheduling(state),
  rescheduleFlow: selectAppointmentConsentsModalOpenRescheduleFlow(state),
  isSignConsentLoading: selectSignAppointmentConsentLoading(state),
});

const mapDispatchToProps = {
  appointmentConsentsModalOpen: appointmentConsentsModalActions.open,
  appointmentConsentsModalClose: appointmentConsentsModalActions.close,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ConsentDetailsPopup/enhance.js